import packageJson from './../../package.json';
import firebaseConfig from './firebase';

interface Config {
  env: 'production' | 'staging' | 'sandbox' | 'test' | 'development';
  name: string;
  rest: {
    uri: string;
  };
  asset: {
    uri: string;
  };
  ws: {
    uri: string;
  };
  sentry: {
    dsn: string;
    env: 'production' | 'staging' | 'sandbox' | 'test';
  };
  cookies: {
    domain: string;
    secure: boolean;
    sameSite: 'strict' | 'Strict' | 'lax' | 'Lax' | 'none' | 'None';
  };
  firebase: {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId: string;
    vapidKey: string;
  };
  constants: {
    page: number;
    pageSize: number;
    dateFormat: string;
  };
}

const config: Config = {
  env: (process.env.NODE_ENV as any) ?? 'development',

  name: packageJson.name,
  asset: {
    uri: process.env.REACT_APP_ASSET_URI ?? 'https://api.wiredesk.ogatepay.com/api/assets',
  },
  rest: {
    uri: process.env.REACT_APP_BASE_URI ?? 'https://api.wiredesk.ogatepay.com/api',
  },
  ws: {
    uri: process.env.REACT_APP_WS_URI ?? 'wss://api.wiredesk.ogatepay.com/graphql',
  },
  sentry: {
    dsn: process.env.REACT_APP_SENTRY_DSN ?? 'https://examplePublicKey@o0.ingest.sentry.io/0',
    env: process.env.REACT_APP_SENTRY_ENV as any,
  },
  cookies: {
    domain: window.location.hostname,
    secure: false,
    sameSite: 'lax',
  },
  firebase: firebaseConfig,
  constants: {
    page: 1,
    pageSize: 10,
    dateFormat: '',
  },
};

export default config;
